import React from 'react';
import { WaitlistForm } from './WaitlistForm';
export function Footer() {
  return <footer className="bg-slate-50 pt-20 pb-10 border-t border-slate-200" data-id="element-37">
      <div className="container mx-auto px-4" data-id="element-38">
        <div className="flex flex-col items-center text-center max-w-2xl mx-auto mb-16" data-id="element-39">
          <img src="https://cdn.magicpatterns.com/uploads/8FSu8CQTWvoMhpfjhng9JD/Vytaniq_Brandd_Logo.png" alt="Vytaniq" className="h-12 mb-6" data-id="element-40" />
          <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-41">
            Ready to understand your health?
          </h2>
          <p className="text-lg text-slate-600 mb-8" data-id="element-42">
            Join the waitlist today and be the first to know when Vytaniq
            launches.
          </p>
          <WaitlistForm showCheckbox={true} className="w-full max-w-md mx-auto" buttonText="Get Early Access" data-id="element-43" />
        </div>

        <div className="border-t border-slate-200 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-slate-500" data-id="element-44">
          <p data-id="element-45">&copy; {new Date().getFullYear()} Vytaniq. All rights reserved.</p>
          <div className="flex gap-6" data-id="element-46">
            <a href="#" className="hover:text-teal-600 transition-colors" data-id="element-47">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-teal-600 transition-colors" data-id="element-48">
              Terms of Service
            </a>
            <a href="#" className="hover:text-teal-600 transition-colors" data-id="element-49">
              Contact
            </a>
          </div>
        </div>
      </div>
    </footer>;
}